module.exports = __webpack_public_path__ + "img/y2.ac68dae7.png";